import React, { useState, useRef, useLayoutEffect } from 'react';
import PropTypes from 'prop-types';
import { createPortal } from 'react-dom';

const Hover = ({ text, children }) => {
    const [visible, setVisible] = useState(false);
    const [mounted, setMounted] = useState(false);
    const tooltipRef = useRef(null);
    const wrapperRef = useRef(null);
    const [coords, setCoords] = useState({ top: 0, left: 0 });

    const updateTooltipPosition = () => {
        if (!wrapperRef.current || !tooltipRef.current) return;

        const wrapRect = wrapperRef.current.getBoundingClientRect();
        const tipRect = tooltipRef.current.getBoundingClientRect();
        const scrollY = window.scrollY;
        const scrollX = window.scrollX;
        const margin = 8;

        let top = wrapRect.top + scrollY - tipRect.height - 6;
        if (top < scrollY + margin) {
            top = wrapRect.top + scrollY + wrapRect.height + 6;
        }

        let left = wrapRect.left + scrollX + (wrapRect.width - tipRect.width) / 2;
        const minLeft = scrollX + margin;
        const maxLeft = scrollX + window.innerWidth - tipRect.width - margin;
        left = Math.min(Math.max(left, minLeft), maxLeft);

        setCoords({ top, left });
    };

    const showTooltip = () => {
        updateTooltipPosition();
        if (!mounted) setMounted(true);
        setVisible(true);
    };

    const hideTooltip = () => {
        setVisible(false);
    };

    // po tom, co `mounted` i `visible` jsou true
    useLayoutEffect(() => {
        if (mounted && visible) {
            updateTooltipPosition();
        }
    }, [mounted, visible]);

    return (
        <>
      <span
          ref={wrapperRef}
          onMouseEnter={showTooltip}
          onMouseLeave={hideTooltip}
          className="relative inline-block"
      >
        <span className="cursor-pointer text-gray-400 hover:text-gray-600">
          {children}
        </span>
      </span>

            {mounted &&
                createPortal(
                    <div
                        ref={tooltipRef}
                        role="tooltip"
                        className={`absolute z-[9999] w-auto max-w-xs p-2 text-sm text-center rounded-lg shadow-lg
              transition-opacity duration-300 ease-in-out
              ${visible ? 'opacity-100 pointer-events-auto' : 'opacity-0 pointer-events-none'}
              dark:bg-[rgba(0,0,0,0.5)] bg-[rgba(255,255,255,0.8)]
              dark:text-white text-gray-800
              border dark:border-[rgba(255,255,255,0.3)] border-[rgba(0,0,0,0.2)] backdrop-blur-lg`}
                        style={{
                            top: `${coords.top}px`,
                            left: `${coords.left}px`,
                            WebkitBackdropFilter: 'blur(8px)',
                        }}
                    >
                        {text}
                    </div>,
                    document.body
                )}
        </>
    );
};

Hover.propTypes = {
    text: PropTypes.node.isRequired,
    children: PropTypes.node.isRequired,
};

export default Hover;
